module.exports = function getResource(label, vars = []) {
    let resources = {
        freeSamples: 'Free Samples',
        freeSamplesCTA: `Get ${vars[0]} free sample(s) with every order`,
        samplesAddedText: ` sample${vars[0] !== 1 ? 's' : ''} added`,
        done: 'Done'
    };

    return resources[label];
};
